module.exports = __webpack_public_path__ + "media/bootstrap-icons/pause-btn-9c47363e.svg";